module.exports = __webpack_public_path__ + "img/G.3b422858.jpg";